import React, { useEffect, useState } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

import getCountryFromUrl from '@PayseraServiceAgreementBundle/Resources/assets/js/service/getCountryFromUrl';

import {
    PREFERRED_CAREER_COUNTRY_KEY,
    DEFAULT_COUNTRY_CODE,
    INTERNATIONAL_COUNTRY_CODE,
    OTHER_COUNTRY_CODE,
    COUNTRY_DROPDOWN_ID,
} from '../config/constants';
import { localStorageGet, localStorageSet } from '../../services';


const CountryItem = ({ country, withIcon }) =>  country && (
    <div className="country-dropdown-item">
        {withIcon && <span className={`flag-icon-small flag-icon-${country.code}`} />}
        <span>{country.name}</span>
    </div>
);

export const CountryDropdown = ({
    onCountryChange,
    availableCountries,
}) => {
    const [selectedCountry, setSelectedCountry] = useState(null);

    useEffect(() => {
        const urlCountryCode = getCountryFromUrl()?.toLowerCase() ?? DEFAULT_COUNTRY_CODE;
        const storageCountryCode = localStorageGet(PREFERRED_CAREER_COUNTRY_KEY);
        const foundCountry = availableCountries.find(country => country.code === (storageCountryCode || urlCountryCode));
        const initialCountry = foundCountry || availableCountries[availableCountries.length - 1];

        setSelectedCountry(initialCountry);
    }, []);

    const handleCountryClick = (country) => () => {
        if (country.code === selectedCountry.code) {
            return;
        }

        localStorageSet(PREFERRED_CAREER_COUNTRY_KEY, country.code);
        setSelectedCountry(country);

        if (onCountryChange) {
            onCountryChange(country.code);
        }
    };

    const withIcon = code => ![INTERNATIONAL_COUNTRY_CODE, OTHER_COUNTRY_CODE].includes(code);
    const hasIcon = withIcon(selectedCountry?.code);

    return (
        <div className="country-dropdown-container">
            <DropdownButton
                id={COUNTRY_DROPDOWN_ID}
                className={hasIcon ? "caret-bottom" : ''}
                title={
                    <CountryItem
                        country={selectedCountry}
                        withIcon={hasIcon}
                    />
                }
            >
                {availableCountries.map((country) => (
                    <MenuItem
                        key={country.code}
                        onClick={handleCountryClick(country)}
                    >
                        <CountryItem
                            country={country}
                            withIcon={withIcon(country.code)}
                        />
                    </MenuItem>
                ))}
            </DropdownButton>
        </div>
    );
};

CountryDropdown.propTypes = {
    availableCountries: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired,
    onCountryChange: PropTypes.func,
};
